export { default } from './badge';
export type { BadgeProps } from './types';
